<template>
  <v-div
    v-if="shouldShow"
    class="EthicsInformation"
    border-inverted-bottom-thick
    mt-3
    pb-3
  >
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">Ethics</h2>
    <v-div v-if="hasGainedEthicsApproval" pl-2 font-smaller>
      The author(s) declare that they have sought and gained approval from the
      relevant ethics committee/IRB for this research and its publication.
    </v-div>
    <v-div v-else pl-2 font-smaller
      >The author(s) have declared ethics committee/IRB approval is not relevant
      to this content</v-div
    >
  </v-div>
</template>

<script>
export default {
  name: "EthicsInformation",
  props: {
    article: { type: Object, required: true },
  },
  computed: {
    shouldShow() {
      const { article = {} } = this;
      const { gainedEthicsApproval } = article;

      return (
        gainedEthicsApproval === "YES" ||
        gainedEthicsApproval === "NOT_RELEVANT"
      );
    },
    hasGainedEthicsApproval() {
      return this.article.gainedEthicsApproval === "YES";
    },
  },
};
</script>
